export const extractError = err => {
    // console.log('got here err : ', err);
    if (err.message && err.message.errors) {
        // console.log('returning array');
        return err.message.errors;
    }
    if (err.message && err.message.error) {
        return err.message.error;
    }
    if (err.message && typeof err.message === 'string') {
        return err.message;
    }
    if (err.message && err.message.response && err.message.response.errorMessage) {
        return err.message.response.errorMessage;
    }
    if (err.message && err.message.response && err.message.response.result && err.message.response.result.message) {
        return err.message.response.result.message;
    }
    // console.log('returning string');
    return 'Something went wrong';
}